const roles = {
    USER: 'user'
}

export default roles;